/* eslint-disable sort-keys-fix/sort-keys-fix -- CSS-in-JS keys use semantic ordering */
// Backstage SidebarSubmenuItem overrides.
//
// Core source: node_modules/@backstage/core-components/.../SidebarSubmenuItem.esm.js
// JSS name: "BackstageSidebarSubmenuItem". Class keys include item, label and
// selected.
//
// core-components hardcodes greys the nav does not use:
//   - selected.background: "#6f6f6f" with color: common.white, a dark grey block
//   - item/dropdownItem "&:hover".background: navItem?.hoverBackground || "#6f6f6f"
//
// The hover background is fixed through palette.navigation.navItem.hoverBackground
// in theme.ts, which covers both item and dropdownItem hover. The selected state
// and the typography and padding are overridden here, because
// selected.background is hardcoded to #6f6f6f and cannot go through the palette.
//
// The inactive text colour stays on palette.navigation.color (near-black). It is
// not overridden to the emphasis blue, which is only for the selected item.
//
// Mode-aware through CSS variables: light and dark share this object, and the
// tokens flip per data-theme-mode in tokens.css.

const sidebarSubmenuItemBase = {
  // Inset on the wrapper so the full-width selected pill gets white space around
  // it and its rounding shows. A flat key (no nested selector, which crashes the
  // MUI v4 theme-override render).
  itemContainer: {
    padding: '2px var(--ns-space-2)',
  },
  item: {
    // Padding 8 (inset) and a row height of 40, instead of the fixed 48 of
    // core-components.
    height: 40,
    padding: 'var(--ns-space-2)',
  },
  label: {
    // Inactive, the label is content-default (near-black) instead of the
    // MuiLink blue. font-weight inherits from the item, so the selected state
    // (item fontWeight 700) makes the label bold without a nested selector
    // (which crashes the MUI v4 theme-override render).
    fontSize: 'var(--ns-font-size-m)',
    fontWeight: 'inherit',
    color: 'var(--ns-color-fg-default)',
  },
  selected: {
    background: 'var(--ns-color-bg-selected-default)',
    color: 'var(--ns-color-fg-selected)',
    fontWeight: 700,
    borderRadius: 'var(--ns-control-radius)',
  },
};

export const BackstageSidebarSubmenuItemOverrides = sidebarSubmenuItemBase;
